import React, { useState } from 'react'
import { LiveEnabledModalProps } from './types'
import componentStyles from '../GigStatus/GigStatus.module.scss'
import styles from './LiveEnabledModal.module.scss'
import classnames from 'classnames'
import ConfirmModal from '@bt-react/components/ConfirmModal'
import Countdown from '@bt-react/components/Countdown'

const LiveEnabledModal: React.FunctionComponent<LiveEnabledModalProps> = props => {

  const [ dismissed, setDismissed ] = useState(false)

  const confirm = () => setDismissed(true)

  return !dismissed ? <ConfirmModal
    content={{
      header: `Reminder: It's time to start!`,
      body: <>
        <p>When you're ready, click "Start talk" to go live to your audience.</p>
        <Countdown
          countdownText=''
          date={props.date}
          className={classnames(componentStyles[`gigStatus__timer`], styles['live-enabled-countdown'])}
          allowMinus={true}
        /></>,
      confirm: 'OK',
      cancel: ''
    }}
    onConfirm={confirm}
    isOpen={true}
  /> : null

}

export default LiveEnabledModal
